import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './QuickRaceRow.module.scss';
import cn from 'classnames';
import racePhoto from '../../../../assets/icons/race-photo.webp';
import Heading from '../../../Typography/Heading/Heading';
import TrackInfoBlock from './TrackInfoBlock/TrackInfoBlock';
import Button from '../../../Button/Button';
const QuickRaceRow = ({ raceInfo, darkMode, onClick }) => {
    const handleClick = () => {
        onClick(raceInfo);
    };
    return (_jsxs("div", Object.assign({ className: cn(styles.element, darkMode && styles['isDarkMode']) }, { children: [_jsx("img", { src: racePhoto, alt: 'race-photo', className: styles.img }), _jsxs("div", Object.assign({ className: styles.track }, { children: [_jsx(Heading, { title: raceInfo.eventInfo, size: 5, fontWeight: 600 }), _jsx(TrackInfoBlock, { raceInfo: raceInfo })] })), _jsx("div", Object.assign({ className: cn('d-flex align-items-center justify-content-end', styles.buttonWrapper) }, { children: _jsx(Button, { text: 'select', color: 2, className: cn(styles.button), size: 'xs', height: 'xs', onClick: handleClick }) }))] })));
};
export default QuickRaceRow;
